export class CodebookModel {
    id:number;
    name:string;
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/models/codebook.model.ts